import "./import_jquery";

const mobileBreakpoint = 1024;
let globalMessageCounter = 0;
let visibleMessages = [];
document.getElementById('hero_video').playbackRate = 0.8;  // Set to 0.5x speed by default


function handleClose(index, position) { // We now also pass the position to this function
    const alertContainer = $(`#alert-container-${index}`);
    alertContainer.addClass('animate-fadeOut');

    setTimeout(() => {
        alertContainer.remove();

        // Remove the position from the visibleMessages array
        const idx = visibleMessages.indexOf(position);
        if (idx > -1) {
            visibleMessages.splice(idx, 1);
        }

        // Check if there are no more visible messages and clear the array if so
        if (!visibleMessages.length) {
            visibleMessages = [];
        }
    }, 300);
}

function getNextPosition() {
    console.log("getNextPosition " + visibleMessages);
    // Starting position
    let position = 1;

    // While the position is occupied, increase the position counter
    while (visibleMessages.includes(position)) {
        position++;
    }

    return position;
}

function displayMessages(messages) {
    messages.forEach((message) => {
        const type = message.type;
        let bgColor = '';
        let symbol = '';
        const currentCounter = globalMessageCounter;
        const position = getNextPosition();

        switch (type) {
            case 'error':
                bgColor = 'bg-red-600';
                symbol = 'M3.72 3.72a.75.75 0 011.06 0L8 6.94l3.22-3.22a.75.75 0 111.06 1.06L9.06 8l3.22 3.22a.75.75 0 11-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 01-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 010-1.06z';
                break;
            case 'success':
                bgColor = 'bg-green-600';
                symbol = 'M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z';
                break;
            case 'info':
                bgColor = 'bg-blue-500';
                symbol = 'M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8zm6.5-.25A.75.75 0 017.25 7h1a.75.75 0 01.75.75v2.75h.25a.75.75 0 010 1.5h-2a.75.75 0 010-1.5h.25v-2h-.25a.75.75 0 01-.75-.75zM8 6a1 1 0 100-2 1 1 0 000 2z';
                break;
            case 'warning':
                bgColor = 'bg-yellow-600';
                symbol = 'M8.22 1.754a.25.25 0 00-.44 0L1.698 13.132a.25.25 0 00.22.368h12.164a.25.25 0 00.22-.368L8.22 1.754zm-1.763-.707c.659-1.234 2.427-1.234 3.086 0l6.082 11.378A1.75 1.75 0 0114.082 15H1.918a1.75 1.75 0 01-1.543-2.575L6.457 1.047zM9 11a1 1 0 11-2 0 1 1 0 012 0zm-.25-5.25a.75.75 0 00-1.5 0v2.5a.75.75 0 001.5 0v-2.5z';
                break;
            default:
                bgColor = 'bg-blue-500';
                symbol = 'M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8zm6.5-.25A.75.75 0 017.25 7h1a.75.75 0 01.75.75v2.75h.25a.75.75 0 010 1.5h-2a.75.75 0 010-1.5h.25v-2h-.25a.75.75 0 01-.75-.75zM8 6a1 1 0 100-2 1 1 0 000 2z';
        }

        const alertContainer = $(`
            <div id="alert-container-${currentCounter}"
                 class="fixed top-0 right-0 z-50 p-2 transition-opacity opacity-100 duration-300"
                 style="top: ${position * 90}px; right: 0px; display: none;">
                <div class="flex w-96 shadow-lg rounded-lg">
                    <div id="icon-container-${currentCounter}" class="py-4 px-6 rounded-l-lg flex items-center">
                        <!-- SVG for icon will be injected via JavaScript -->
                    </div>
                    <div class="px-4 py-6 bg-white rounded-r-lg flex justify-between items-center w-full border border-l-transparent border-gray-200">
                        <div>${message.message}</div>
                        <button onclick="handleClose(${currentCounter})">
                            <!-- Close icon SVG here -->
                        </button>
                    </div>
                </div>
            </div>
        `);

        $("#root").append(alertContainer);


        // The following lines of code remain unchanged from your original function:
        const iconContainer = $(`#icon-container-${currentCounter}`);
        iconContainer.addClass(bgColor);
        iconContainer.html(`<svg xmlns="http://www.w3.org/2000/svg" class="fill-current text-white" viewBox="0 0 16 16" width="20" height="20"><path fill-rule="evenodd" d="${symbol}"></path></svg>`);

        alertContainer.show();

        setTimeout(() => handleClose(currentCounter, position), 5000);

        visibleMessages.push(position);

        globalMessageCounter++;
    });
}

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}
function toggleCloseMenu() {
    const sideMenu = $("#side-menu");
    const hamburgerBtn = $("#hamburger-btn");

    // Toggle the menu and button states
    hamburgerBtn.toggleClass("-translate-x-60");
    $("#hamburger-btn object").toggleClass("hidden");

    if (sideMenu.hasClass("translate-x-0")) {
        // If the side menu is open, close it
        sideMenu.removeClass("translate-x-0").addClass("translate-x-full");
    } else {
        // If the side menu is closed, open it
        sideMenu.removeClass("translate-x-full").addClass("translate-x-0");
    }
}

$(function () {
    function updateClasses() {
        var $myDiv = $('#hero'); // Replace 'myDiv' with your actual div ID
        var $myDiv2 = $('#hero_container'); // Replace 'myDiv' with your actual div ID
        var $myDiv3 = $('#main-header'); // Replace 'myDiv' with your actual div ID

        if ($myDiv.length > 0 && $myDiv2.length > 0) {
            if (window.innerWidth >= 1024 || window.innerHeight >= 1024) {
                $myDiv.attr('class', 'h-screen bg-center bg-cover flex items-center justify-center hero-load');
                $myDiv2.attr('class', 'flex items-center justify-center h-screen z-10 w-full');
                $myDiv3.addClass('absolute');
            } else {
                $myDiv.attr('class', '');
                $myDiv2.attr('class', '');
                $myDiv3.removeClass('absolute');
            }
        }

    }

    // Initial class update
    updateClasses();

    // Attach resize event handler
    $(window).resize(function () {
        updateClasses();
    });


    $("#hamburger-btn").click(function () {
        toggleCloseMenu();
    });

    const mobileSVGPath = "/static/images/go-eliza-logo-no-background.svg"; // Path to the mobile SVG
    const logoObject = document.getElementById('logoObject');
    let currentSVGPath = (logoObject ? logoObject.data : null);

    function swapSVG() {
        const screenWidth = $(window).width();

        if (logoObject && screenWidth <= mobileBreakpoint && currentSVGPath !== mobileSVGPath) {
            // Change data attribute to load mobile SVG
            logoObject.data = mobileSVGPath;
            currentSVGPath = mobileSVGPath;
        } else if (logoObject && screenWidth > mobileBreakpoint && currentSVGPath !== "/static/images/go-eliza-logo-white-no-background.svg") {
            // Reset to the original SVG
            logoObject.data = "/static/images/go-eliza-logo-white-no-background.svg";
            currentSVGPath = "/static/images/go-eliza-logo-white-no-background.svg";
        }
    }

    // Call the function on page load and resize
    swapSVG();
    $(window).resize(swapSVG);

    $("#newsletter_sign_up_form").on("submit", function(e) {
        e.preventDefault(); // Prevent the default form submission

        let email = $(this).find("input[type='email']").val();
        const csrftoken = getCookie('csrftoken'); // Get CSRF token from cookies

        $.ajax({
            url: '/accounts/subscribe/',  // Adjust this if necessary
            method: 'POST',
            headers: {
                'X-CSRFToken': csrftoken
            },
            data: {
                email: email
            },
            success: function (response) {
                displayMessages([response]);
            },
            error: function () {
                alert('error');
                displayMessages([response]);
            }
        });
    });

});

document.addEventListener("DOMContentLoaded", function() {

    const hero_video = document.getElementById("hero_video");
    const hero_overlay = document.getElementById("hero_overlay");
    function updateBackgroundImage() {
        const screenWidth = window.innerWidth;

        if (screenWidth <= mobileBreakpoint) {
            hero_video.style.display = "none";
            hero_overlay.style.display = "none";
        } else {
            hero_video.style.display = "block";
            hero_overlay.style.display = "block";
        }
    }

    updateBackgroundImage();

    window.addEventListener("resize", updateBackgroundImage);
});

// Add a click event listener to the document body
$("body").click(function(event) {
    const sideMenu = $("#side-menu");
    const hamburgerBtn = $("#hamburger-btn");
    // Check if the click target is not within the side menu or hamburger button
    if (
        !sideMenu.is(event.target) &&
        !sideMenu.has(event.target).length &&
        !hamburgerBtn.is(event.target) &&
        !hamburgerBtn.has(event.target).length
    ) {
        // Close the side menu if it's open
        if (sideMenu.hasClass("translate-x-0")) {
            toggleCloseMenu();
        }
    }
});

window.displayMessages = displayMessages;